// extracted by mini-css-extract-plugin
export default {"ganttVerticalContainer":"gantt_ganttVerticalContainer__VELr9","horizontalContainer":"gantt_horizontalContainer__TxVhm","wrapper":"gantt_wrapper__QsaGj"};